import { Fab } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { IconId } from '@src/main/ui/components/common/Icon/IconId';
import { FC } from 'react';

interface Props {
  onClick: () => void;
  icon: IconId;
}

const FabButton: FC<Props> = ({ onClick, icon }) => (
  <Fab onClick={onClick} sx={{ fontSize: '12px', zIndex: 1 }} color="secondary">
    <Icon iconId={icon} />
  </Fab>
);

export default FabButton;
